import React, { useState, useEffect, useRef } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import '../shared.css';
import LoadingOverlay from '../LoadingOverlay';

function StockTransfer() {
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [itemOptions, setItemOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemId, setItem] = useState(0);

    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();

    const [OrionQty, setOrionQty] = useState(0);
    const [UbcityQty, setUbcityQty] = useState(0);
    const [PMCChennaiQty, setPMCChennaiQty] = useState(0);
    const [PMCBangaloreQty, setPMCBangaloreQty] = useState(0);
    const [HYDForumQty, setHYDForumQty] = useState(0);
    const [InorbitQty, setInorbitQty] = useState(0);
    const [LandTQty, setLandTQty] = useState(0);
    const [VRQty, setVRQty] = useState(0);
    const [ShantiniketanQty, setShantiniketanQty] = useState(0);
    const [HeadOfficeQty, setHeadOfficeQty] = useState(0);

    const [selectedOption, setSelectedOption] = useState('out');

    useEffect(() => {
        let OrionQty = 0, UbcityQty = 0, PMCChennaiQty = 0, PMCBangaloreQty = 0;
        let HYDForumQty = 0, InorbitQty = 0, LandTQty = 0, VRQty = 0;
        let ShantiniketanQty = 0, HeadOfficeQty = 0;

        dataItem.forEach(item => {
            OrionQty += item.OrionQty;
            UbcityQty += item.UbcityQty;
            PMCChennaiQty += item.PMCChennaiQty;
            PMCBangaloreQty += item.PMCBangaloreQty;
            HYDForumQty += item.HYDForumQty;
            InorbitQty += item.InorbitQty;
            LandTQty += item.LandTQty;
            VRQty += item.VRQty;
            ShantiniketanQty += item.ShantiniketanQty;
            HeadOfficeQty += item.HeadOfficeQty;
        });

        setOrionQty(OrionQty);
        setUbcityQty(UbcityQty);
        setPMCChennaiQty(PMCChennaiQty);
        setPMCBangaloreQty(PMCBangaloreQty);
        setHYDForumQty(HYDForumQty);
        setInorbitQty(InorbitQty);
        setLandTQty(LandTQty);
        setVRQty(VRQty);
        setShantiniketanQty(ShantiniketanQty);
        setHeadOfficeQty(HeadOfficeQty);
    }, [dataItem]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        const startDate = getFormattedStartDate();
        const currentDate = getFormattedCurrentDate();
        setFromDate(startDate);
        setToDate(currentDate);
        fetchBranchData();
        fetchItemData();
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        if (fromDate && toDate) {
            fetchTableData(fromDate, toDate);
        }
    }, [fromDate, toDate]);

    const handleBranchSelect = (selectedOption) => {
        setSelectedBranch(selectedOption);
        setDataItem([]);
    };

    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        const id = selectedOption ? selectedOption.value : '';
        setItem(id);
        setDataItem([]);
    };

    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({ label: customer.Name, value: customer.Id }));
                setBranchOptions(options);
            })
            .catch((error) => console.error('Error fetching branch data:', error));
    };

    const fetchItemData = () => {
        fetchData('ReportApi', `/Item/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Code + '-' + customer.Name,
                    value: customer.Id,
                }));
                setItemOptions(options);
            })
            .catch((error) => console.error('Error fetching branch data:', error));
    };

    const getFormattedCurrentDate = () => new Date().toISOString().split('T')[0];

    const getFormattedStartDate = () => {
        const d = new Date();
        d.setDate(1);
        return d.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => setFromDate(e.target.value);
    const handleToDateChange = (e) => setToDate(e.target.value);

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);
    const loadingRef = useRef(false);

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
        setDataItem([]);
    };

    const fetchTableData = async (fDate, tDate) => {
        const effectiveFromDate = fDate || fromDate;
        const effectiveToDate = tDate || toDate;
        if (hasReadReportPermission && !loadingRef.current && effectiveFromDate && effectiveToDate) {
            setDataItem([]);
            loadingRef.current = true;
            setLoading(true);
            try {
                if (selectedOption === 'out') {
                    const response = await fetchData('ReportApi', `/StockTransferout/${effectiveFromDate}/${effectiveToDate}/${companyId}/${branchId}/${itemId}`, token);
                    if (response.responseCode === '1111') setDataItem(response.response_data);
                } else if (selectedOption === 'in') {
                    const response = await fetchData('ReportApi', `/StockTransferint/${effectiveFromDate}/${effectiveToDate}/${companyId}/${branchId}/${itemId}`, token);
                    if (response.responseCode === '1111') setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Sales Details:', error);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
    };

    const handleSearch = (event) => setSearchQuery(event.target.value);

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Stock');

        let headerCaption = selectedOption === 'out'
            ? `Stock Transfer Out From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`
            : `Stock Transfer In From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`;

        worksheet.mergeCells('A1:V1');
        const captionCell = worksheet.getCell('A1');
        captionCell.value = headerCaption;
        captionCell.font = { bold: true, size: 14 };
        captionCell.alignment = { vertical: 'middle', horizontal: 'left' };

        const headerRowValues = [
            'Code', 'Item', 'Purchase Rate', 'MRP', 'GST%', 'HSN Code', 'PG', 'IG', 'ISG', 'PF', 'Category', 'Group',
            'UB City', 'Orion Mall', 'PMC Chennai', 'PMC Bangalore', 'Inorbit Mall', 'L&T Metro Mall', 'VR Mall', 'Hyderabad Forum', 'Shantiniketan', 'Ecomm'
        ];
        const headerRow = worksheet.addRow(headerRowValues);
        headerRow.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB6D7A8' } };
            cell.font = { bold: true, color: { argb: 'FF000000' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        worksheet.columns = headerRowValues.map(() => ({ width: 18 }));

        const rightAlignColumns = [
            'Purchase Rate', 'MRP', 'GST%', 'UB City', 'Orion Mall', 'PMC Chennai', 'PMC Bangalore', 'Inorbit Mall',
            'L&T Metro Mall', 'VR Mall', 'Hyderabad Forum', 'Shantiniketan', 'Ecomm'
        ];

        filteredDataItem.forEach((rowData) => {
            const dataRow = [
                parseFloat(rowData.Code), rowData.Name,
                parseFloat(rowData.PurchaseRate.toFixed(2)), parseFloat(rowData.MRP.toFixed(2)),
                parseFloat(rowData.GSTRate), rowData.HSNCode,
                rowData.PG, rowData.IG, rowData.ISG, rowData.PF,
                rowData.CategoryName, rowData.ItemGroupName,
                parseFloat(rowData.UbcityQty), parseFloat(rowData.OrionQty),
                parseFloat(rowData.PMCChennaiQty), parseFloat(rowData.PMCBangaloreQty),
                parseFloat(rowData.InorbitQty), parseFloat(rowData.LandTQty),
                parseFloat(rowData.VRQty), parseFloat(rowData.HYDForumQty),
                parseFloat(rowData.ShantiniketanQty), parseFloat(rowData.HeadOfficeQty)
            ];
            const row = worksheet.addRow(dataRow);
            row.eachCell((cell, colNumber) => {
                const headerName = headerRowValues[colNumber - 1];
                cell.alignment = { vertical: 'middle', horizontal: rightAlignColumns.includes(headerName) ? 'right' : 'center' };
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            });
        });

        const totalRowValues = [
            '', 'Total', '', '', '', '', '', '', '', '', '', '',
            UbcityQty, OrionQty, PMCChennaiQty, PMCBangaloreQty, InorbitQty, LandTQty, VRQty, HYDForumQty, ShantiniketanQty, HeadOfficeQty
        ];
        const totalRow = worksheet.addRow(totalRowValues);
        totalRow.font = { bold: true };
        totalRow.eachCell((cell, colNumber) => {
            const headerName = headerRowValues[colNumber - 1];
            cell.alignment = { vertical: 'middle', horizontal: rightAlignColumns.includes(headerName) ? 'right' : 'center' };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), 'Stock_Transfer.xlsx');
    };

    const itemOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...itemOptions];
    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];

    return (
        <div className="pg-container">
            <div className="pg-header">
                <h5 className="pg-title">Stock Transfer Report</h5>
                <div className="pg-header-actions">
                    <div className="pg-date-row">
                        <div className="pg-field">
                            <label className="pg-label" style={{ background: 'var(--pg-bg)' }}>From Date</label>
                            <input className="pg-input" type="date" value={fromDate} onChange={handleFromDateChange} />
                        </div>
                        <div className="pg-field">
                            <label className="pg-label" style={{ background: 'var(--pg-bg)' }}>To Date</label>
                            <input className="pg-input" type="date" value={toDate} onChange={handleToDateChange} />
                        </div>
                        <RadioGroup
                            aria-label="viewOption"
                            name="viewOption"
                            value={selectedOption}
                            onChange={handleChange}
                            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                        >
                            <FormControlLabel value="out" control={<Radio />} label="Out" />
                            <FormControlLabel value="in" control={<Radio />} label="In" />
                        </RadioGroup>
                        <button className="pg-btn pg-btn-outline" onClick={() => fetchTableData()} disabled={loading}>
                            <RefreshIcon /> {loading ? 'Loading...' : 'Refresh'}
                        </button>
                        <button className="pg-btn pg-btn-success" onClick={handleExportExcel}>
                            <FeedIcon /> Excel
                        </button>
                        <button className="pg-btn pg-btn-outline" onClick={() => setShowSearchInput(v => !v)}>
                            <SearchIcon /> Search
                        </button>
                    </div>
                    {showSearchInput && (
                        <input className="pg-input pg-search-input" placeholder="Search…"
                            value={searchQuery} onChange={handleSearch} autoFocus style={{ marginTop: 6 }} />
                    )}
                </div>
            </div>

            {loading && <LoadingOverlay />}

            <div className="pg-table-wrap">
                <table className="pg-table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Item</th>
                            <th>Purchase Rate</th>
                            <th>MRP</th>
                            <th>GST%</th>
                            <th>HSN Code</th>
                            <th>PG</th>
                            <th>IG</th>
                            <th>ISG</th>
                            <th>PF</th>
                            <th>Category</th>
                            <th>Group</th>
                            <th>UB City</th>
                            <th>Orion Mall</th>
                            <th>PMC Chennai</th>
                            <th>PMC Bangalore</th>
                            <th>Inorbit Mall</th>
                            <th>L&T Metro Mall</th>
                            <th>VR Mall</th>
                            <th>Hyderabad Forum</th>
                            <th>Shantiniketan</th>
                            <th>Ecomm</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredDataItem.map((data, index) => (
                            <tr key={index}>
                                <td>{data.Code}</td>
                                <td>{data.Name}</td>
                                <td style={{ textAlign: 'right' }}>{data.PurchaseRate.toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>{data.MRP.toFixed(2)}</td>
                                <td>{data.GSTRate}</td>
                                <td>{data.HSNCode}</td>
                                <td>{data.PG}</td>
                                <td>{data.IG}</td>
                                <td>{data.ISG}</td>
                                <td>{data.PF}</td>
                                <td>{data.CategoryName}</td>
                                <td>{data.ItemGroupName}</td>
                                <td>{data.UbcityQty}</td>
                                <td>{data.OrionQty}</td>
                                <td>{data.PMCChennaiQty}</td>
                                <td>{data.PMCBangaloreQty}</td>
                                <td>{data.InorbitQty}</td>
                                <td>{data.LandTQty}</td>
                                <td>{data.VRQty}</td>
                                <td>{data.HYDForumQty}</td>
                                <td>{data.ShantiniketanQty}</td>
                                <td>{data.HeadOfficeQty}</td>
                            </tr>
                        ))}
                        <tr style={{ background: '#1c2a3a', color: '#fff', fontWeight: 700 }}>
                            <td colSpan={12}></td>
                            <td>{UbcityQty.toFixed(2)}</td>
                            <td>{OrionQty.toFixed(2)}</td>
                            <td>{PMCChennaiQty.toFixed(2)}</td>
                            <td>{PMCBangaloreQty.toFixed(2)}</td>
                            <td>{InorbitQty.toFixed(2)}</td>
                            <td>{LandTQty.toFixed(2)}</td>
                            <td>{VRQty.toFixed(2)}</td>
                            <td>{HYDForumQty.toFixed(2)}</td>
                            <td>{ShantiniketanQty.toFixed(2)}</td>
                            <td>{HeadOfficeQty.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
        </div>
    );
}

export default StockTransfer;
